module.exports = __webpack_public_path__ + "favicon-byob-fallback.3188087bc88cad46085a386098494a47.png";